import React from "react";
import { Stack, Paper, Typography, Chip, Box } from "@mui/material";
import CardHeaderAvatar from "../CardHeaderAvatar";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { useTheme } from "@mui/material/styles";
import { BulletinItem } from "../../utils/BulletinBoardAPIRequest";


interface BulletinBoardProps {
    bulletinMessages: BulletinItem[];
}

const BulletinBoard: React.FC<BulletinBoardProps> = ({ bulletinMessages }) => {
    const theme = useTheme();
    return (
        <Stack spacing={2}>
            {bulletinMessages.map((message, idx) => {
                // Use a random color from a palette for each bulletin item
                const colors = ["#f44336", "#ff9800", "#4caf50", "#2196f3", "#9c27b0", "#00bcd4"];
                const color = colors[idx % colors.length];
                return (
                    <Paper key={message._id} sx={{ p: 2, borderLeft: `4px solid ${color}` }}>
                        <Stack direction="row" alignItems="flex-start" spacing={2}>
                            <Box sx={{ flex: 1 }}>
                                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5 }}>
                                    {message.title}
                                </Typography>
                                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                                    {message.content}
                                </Typography>
                                <Stack direction="row" alignItems="center" spacing={1}>
                                    <Chip label={"HR"} size="small" variant="outlined" />
                                    <Typography variant="caption" color="text.secondary">
                                        {message.createdAt ? new Date(message.createdAt).toLocaleDateString() : "N/A"}
                                    </Typography>
                                </Stack>
                            </Box>
                        </Stack>
                    </Paper>
                );
            })}
        </Stack>
    );
};

export default BulletinBoard;
